import { produce } from 'immer';
import { sortBy } from 'lodash';
import * as types from './locationTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    records: [],
    tableHeaders: [],
    totalRecords: 0,
    loading: true,
    pointOfInterestOptions: [],
    pointOfInterestCache: {}, // Cache POI options by building: { eventId_buildingId: options }
    pointOfInterestFetched: false,
    currentBuildingId: null, // Track current building for POI options
    buildingOptions: [],
    buildingFetched: false,
    fetchedEventId: null,
    pointrSiteIdError: '',
};

const actionHandlers = {
    [types.GET_LOCATIONS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_LOCATIONS.SUCCESS]: produce((draft, { total, locations }) => {
        const records = locations.map((item) => ({
            ...item,
            usageInMap: item?.pin
                ? `${item?.pin?.mapName} - ${item?.pin?.name}`
                : '',
            mapLink: item?.material?.name,
        }));
        const tableHeaders = [];
        // set header
        if (draft.tableHeaders.length === 0 && records.length > 0) {
            sortBy(Object.keys(records[0])).forEach((headerKey) => {
                tableHeaders.push({
                    field: headerKey,
                    headerName: headerKey,
                });
            });
            draft.tableHeaders = tableHeaders;
        }
        draft.records = records;
        draft.totalRecords = total;
        draft.loading = false;
    }),
    [types.GET_LOCATIONS.FAILURE]: produce((draft) => {
        draft.loading = false;
    }),
    [types.RESET_LOCATIONS]: produce((draft) => {
        draft.records = [];
        draft.totalRecords = 0;
        draft.loading = true;
    }),
    [types.GET_POINTR_POINT_OF_INTEREST_OPTIONS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_POINTR_POINT_OF_INTEREST_OPTIONS.SUCCESS]: produce(
        (draft, { options, eventId, buildingId }) => {
            draft.pointOfInterestOptions = options;
            draft.loading = false;
            draft.pointOfInterestFetched = true;
            draft.fetchedEventId = eventId;
            draft.currentBuildingId = buildingId;

            // Cache the options for this building
            if (buildingId) {
                const cacheKey = `${eventId}_${buildingId}`;
                draft.pointOfInterestCache[cacheKey] = options;
            }
        }
    ),
    [types.GET_POINTR_POINT_OF_INTEREST_OPTIONS.FAILURE]: produce((draft) => {
        draft.loading = false;
        draft.pointrSiteIdError =
            'Error while fetching record.Please try again';
    }),
    [types.SET_POINTR_SITE_ID_ERROR]: produce((draft, { errorMessage }) => {
        draft.pointrSiteIdError = errorMessage;
    }),
    [types.GET_POINTR_BUILDING_OPTIONS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_POINTR_BUILDING_OPTIONS.SUCCESS]: produce(
        (draft, { options, eventId }) => {
            draft.buildingOptions = options;
            draft.loading = false;
            draft.buildingFetched = true;
            draft.fetchedEventId = eventId;
        }
    ),
    [types.GET_POINTR_BUILDING_OPTIONS.FAILURE]: produce((draft) => {
        draft.loading = false;
        draft.pointrSiteIdError =
            'Error while fetching buildings. Please try again';
    }),
    [types.CLEAR_POINTR_POI_OPTIONS]: produce((draft) => {
        draft.pointOfInterestOptions = [];
        draft.pointOfInterestFetched = false;
        draft.currentBuildingId = null;
    }),
};

export default createReducer(initialState, actionHandlers);
